import { computed, ref } from 'vue';
import { useExperiment, useActivateExperiment } from '@/libraries/experiment';
import type { ComputedRef } from 'vue';
import { useQuery } from '@/helpers/composables/useApollo';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { usePersistedTodaysDate } from '@/helpers/composables/usePersistedTodaysDate';
import { storeToRefs } from 'pinia';
import { Platform } from '@/@types/graphql-types';
import {
	GetStartPageJwtvModulesDocument,
	GetStartPageJwtvModulesQuery,
	GetStartPageJwtvModulesQueryVariables,
} from './graphql/queries/GetStartPageJwtvModules.query';
import { toValue } from '@vueuse/core';

const isOverlayDismissed = ref(false);
const overlayUnlocked = ref(true);

export function useStartPageJwtvExperiment() {
	const { activeVariant, trackEvent } = useExperiment('EXP_START_PAGE_JWTV', 'global');
	return { activeVariant, trackEvent, isOverlayDismissed, overlayUnlocked };
}

export function useStartPageJwtvModules() {
	const { activeVariant } = useStartPageJwtvExperiment();
	const isExperimentActive = computed(() => activeVariant.value !== null);

	const { country, language } = storeToRefs(useLanguageStore());
	const { todayDate } = usePersistedTodaysDate();

	const jwtvModulesQuery = useQuery<GetStartPageJwtvModulesQuery, GetStartPageJwtvModulesQueryVariables>(
		GetStartPageJwtvModulesDocument,
		() => ({
			platform: Platform.Web,
			language: toValue(language),
			country: toValue(country),
			dateToday: todayDate.value.toISOString().split('T')[0],
			timezoneOffset: 0,
		}),
		() => ({ enabled: isExperimentActive.value, errorPolicy: 'all' })
	);

	return {
		jwtvModules: computed(() => jwtvModulesQuery.result.value),
		jwtvModulesLoading: jwtvModulesQuery.loading,
		isExperimentActive,
	};
}
